import  { useState, useEffect } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { apiReverify } from '../../api';




const Captcha = ({ onVerify,isVerified }) => {
  const [verified, setVerified] = useState(false)
  
  const { executeRecaptcha } = useGoogleReCaptcha()
  

 
 
  useEffect(() => {
    
    let token = localStorage.getItem("token")
    const handleVerify = async () => {
      if(!token){
       token = await executeRecaptcha("submit")
      localStorage.setItem("token", token)
    }
      if(token) {
      
     const data = await apiReverify(token);
    
        if(data.score > 0.6) {
          setVerified(true);
        }
      }
      onVerify(token)

    };
    if(!isVerified){
    handleVerify();
  }
  }, [executeRecaptcha])

  useEffect(() => {
    const clearScoreTimeout = setTimeout(() => {
      localStorage.removeItem("token");
    }, 5* 10 * 1000); // 5 minutes in milliseconds

    return () => clearTimeout(clearScoreTimeout);
  }, [verified]);


  return (
    verified
    
  );
};

export default Captcha